export const locale = {
  lang: 'en',
  data: {
    projectionEvent: {
      ResidenceRegisteredEvent: 'Residence was succesfully added',
      ResidenceInformationCorrectedEvent: 'Residence was succesfully corrected',
      ResidenceCancelledEvent: 'Residence has been succesfully cancelled',
      ResidenceDateCorrectedEvent: 'Date has been corrected with success',
      ResidenceDefinedAsProfessionalDomicileEvent: 'Residence has been assigned as professional domicile',
      MunicipalityRegisteredEvent: 'Municipality has been registered',
      WorkAddressDefinedAsProfessionalDomicileEvent: 'Work address has been defined as professional domicile',
      SecondaryWorkAddressRegisteredEvent: 'Secondary work address has been registered',
      SecondaryWorkAddressRemovedEvent: 'Secondary work address removed',
      WorkAddressInformationCorrectedEvent: 'Work address information has been corrected',
      WorkAddressEndDateCorrectedEvent: 'Work Address end date corrected',
      WorkAddressEndDateCancelledEvent: 'Work Address end date cancelled',
      WorkAddressStartDateCorrectedEvent: 'Work Address start date corrected',
      ProfessionalDomicileCancelledEvent: 'Future professional domicile has been cancelled',
      SecondaryWorkAddressCancelledEvent: 'Work address has been cancelled',
      CorrespondenceTypeAssignedEvent: 'Correspondence change has been registered',
      CorrespondenceTypeCancelledEvent: 'Correspondence change has been cancelled',
      CorrespondenceTypeDateCorrectedEvent: 'Correspondence date change has been registered',
      MemberPaymentRegisteredEvent: 'Registered payment',
      MemberBillRegisteredEvent: 'Bill added',
      MemberPaymentTransactionLogRegisteredEvent: 'Receipt created',
      MemberAccountingBatchRegisteredEvent: 'Accounting batch added',
      AnnualRegistrationEvent: 'Annual registration added',
      MemberRegistrationActivatedFailedEvent: "Member registration failed",
      WorkAddressEndDateCancelledFailedEvent: "Work address end date cancelled failed"
    },
  },
};
